import tableTemplate from './reactIntradaysMainTable.html';
import { reactIntradaysCols, defaultSortModel } from './intradayColDefs';
import {ReactTableController} from "../reactTableController";
import {intradayOptions} from "../../../views/administration/userReports/UserReportDetailDialogController";
import {BackendService} from "../../../services/BackendService";
import {intradays, VALUES} from "../../../services/arsweb/RoutingPaths";
import {DETAILVIEW} from "./reactIntradaysTable.directive";
import {REPORT_TYPE} from "../../../components/report/ReportModalController";

/** @ngInject */
export function reactIntradaysMainTable() {
    return {
        restrict: 'E',
        scope: {
            filter: '=',
            tableId: '@',
            height: '@',
            selectedKey: '@',
            withSelection: '=',
            parentController: '=',
            selectedAccounts: '=',
            hideColumns: '='
        },
        templateUrl: tableTemplate,
        controller: ReactIntradaysMainTableController,
        controllerAs: 'intradaysMainTableController'
    };
}

/** @ngInject */
export class ReactIntradaysMainTableController extends ReactTableController {

    constructor($scope, userService, arsMainDependencies) {

        super($scope, userService, arsMainDependencies, DETAILVIEW, new BackendService(userService), intradays + VALUES,
            "INTRADAYS", 'intradaysMainTableParams', "intradayID", false, intradayOptions, defaultSortModel);
        this.isUserReport = false;
        intradayOptions.withLastAndUnread = false;
        intradayOptions.withDateRange = false;
        this.backendService.service.config.params.filter = {};
        this.ftsMainDependencies.initCompletedPromise.then(() => this.initGrid(userService));

        const parentOnReport = this.defaultReactGridParams.onReport;
        this.defaultReactGridParams.onReport = (selectedNodes) => {
            this.updateReportTypesForSelection();
            parentOnReport.call(this, selectedNodes);
        };
    }

    initGrid(userService) {

        userService.promise.then(()=> {
            // react account columns
            this.colDefs = reactIntradaysCols(this.translate, userService);
            this.initCols();
            // react gridParameters for account table
            const intradaysGridParams = {
                columnDefs: this.colDefs,
                url: this.backendService.service.getServiceUrl(intradays + VALUES),
                onCellClicked: (row) => {
                    this.state.params.id = row.data.account.accountName;
                    this.showChildDetailsView(row.data[this.rowNodeID])
                }};

            this.reactGridParams = {...this.defaultReactGridParams, ...intradaysGridParams};
        });
    }
    
    updateReportTypesForSelection() {
        const options = this.exportController.reportOptions.options;
        // Remove previous CAMT052 is present
        this.exportController.reportOptions.options = options.filter(opt =>
            opt !== REPORT_TYPE.CAMT052_INTRADAYS
        );

        // Add CAMT052 if flag is true for this grid
        if (this.getCamt05xFlag()) {
            this.exportController.reportOptions.options.push(REPORT_TYPE.CAMT052_INTRADAYS);
        }
    }
}
